import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSheet, UitkSheetContent } from 'uitk-react-sheet';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkTertiaryButton, UitkPrimaryButton } from 'uitk-react-button';
import { UitkToolbar } from 'uitk-react-toolbar';
import styles from '../uitk-date-selector.css';

var getClassNameList = classNames.bind(styles);
var dateSelectorPopoverClassName = 'uitk-date-selector-popover';
var PopoverCalendar = function (props) {
    var isOpen = props.isOpen, triggerRef = props.triggerRef, children = props.children, ctaItems = props.ctaItems, dateSelectorPlayback = props.dateSelectorPlayback, showPlayback = props.showPlayback, showOffset = props.showOffset;
    var submitCta = ctaItems.submitCta, clearDatesCta = ctaItems.clearDatesCta;
    return (React.createElement(UitkSheet, { isVisible: isOpen, type: "popover", triggerRef: triggerRef, onDismiss: ctaItems.closeCta.handler, className: getClassNameList(dateSelectorPopoverClassName), returnFocusOnClose: true, showOverTrigger: !showOffset, applyBlockStartMargin: !!showOffset, disableArrowKeyHandler: true },
        showPlayback && React.createElement(UitkToolbar, null, dateSelectorPlayback),
        React.createElement(UitkSheetContent, { padded: false, className: getClassNameList("".concat(dateSelectorPopoverClassName, "-content")) }, children),
        React.createElement(UitkSpacing, { padding: { inline: 'two', block: 'three' } },
            React.createElement("footer", { className: getClassNameList('uitk-sheet-footer') },
                React.createElement(UitkLayoutFlex, { space: "three", justifyContent: "end" },
                    clearDatesCta.handler && (React.createElement(UitkLayoutFlexItem, null,
                        React.createElement(UitkTertiaryButton, { onClick: clearDatesCta.handler, disabled: clearDatesCta.disabled }, clearDatesCta.label))),
                    submitCta.handler && (React.createElement(UitkLayoutFlexItem, null,
                        React.createElement(UitkPrimaryButton, { onClick: submitCta.handler, disabled: submitCta.disabled }, submitCta.label))))))));
};

export { PopoverCalendar };
